<template>
  <div class="lublin-page__section">
    <div class="lublin-page__section-container">
      <h2 class="lublin-page__section-title">{{ sectionData.title }}</h2>

      <div class="lublin-page__section-content">
        <div class="lublin-page__section-image-card border-colored-image-card">
          <img
            :src="sectionData.image"
            alt="city preview image"
          >
        </div>

        <div class="lublin-page__project-stages-description-block">
          <div class="lublin-page__project-stages-list">
            <div
              v-for="(item, index) in sectionData.items"
              :key="index"
              class="lublin-page__project-stages-list-item"
            >
              <div class="lublin-page__project-stages-list-item-number">{{ index + 1 }}</div>
              <div class="lublin-page__project-stages-list-item-value">{{ item }}</div>
            </div>
          </div>

          <div class="lublin-page__project-stages-actions">
            <router-link-modified
              class="base-btn base-btn--blue"
              :to="sectionData.button_1.url"
            >
              {{ sectionData.button_1.text }}
            </router-link-modified>
            <router-link-modified
              class="base-btn base-btn--green"
              :to="sectionData.button_2.url"
            >
              {{ sectionData.button_2.text }}
            </router-link-modified>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LublinProjectStages',
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
  },
};
</script>
